export default __webpack_public_path__ + "static/media/black_re.0e753476.svg";